import Traits from './Traits';
import RefinementList from '../RefinementList';

const TraitsContainer = ({
  name,
  onFilter,
  value,
  options,
}: {
  name: string;
  options: { value: string; count: number }[];
  value: string[];
  onFilter: (key: string, value: string) => void;
}) => {
  const selectedCount = value.length;
  return (
    <Traits
      itemCount={options.length}
      name={name}
      selectedCount={selectedCount}
      refinementList={
        <RefinementList
          name={name}
          value={value}
          options={options}
          onFilter={onFilter}
        />
      }
    />
  );
};

export default TraitsContainer;
